import { useContext, useEffect, useState } from "react";
import React from "react";
import axios from "axios";
import { BaseUrl, GetPhonePayPaymentLink } from "../../BaseUrl/BaseUrl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import dayjs from "dayjs";
import { ServiceDiscounts } from "../../Components/enum";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import DeliveryTracker from "../../Components/DeliveryTracker/DeliveryTracker.jsx";
import LazySection from "../Home/LazySection.jsx";
import { GetOrderTrackingDetails } from "../../ApiServices/BookingTrack/BookingTrackApi.jsx";
import { t } from "i18next";

const PBOrderDetails = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const location = useLocation();
  const navigate = useNavigate();
  const RazorPayKey = process.env.RazorPayKey;
  const RazorPaySecretKey = process.env.RazorPaySecretKey;
  const RazorPayName = process.env.RazorPayName;
  const order = location?.state?.order;
  const { setLoader } = useContext(LoaderContext);
  const [OrderTrackingDetails, setOrderTrackingDetails] = useState(null)
  // const SGST = 9;
  // const CGST = 9;
  // const Tax = Math.round(((SGST + CGST) / 100) * Number(order.CONVENIENCE_FEE));

  useEffect(() => {
    if (order?.PB_ID !== null && order?.PB_ID !== undefined && order?.PB_ID !== '') {
      GetOrderTrackingDetailsData()
    }
  }, [order])

  const GetOrderTrackingDetailsData = async () => {
    setLoader(true);
    try {
      let response = await GetOrderTrackingDetails(userID, order?.PB_ID, 'Puja'); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setOrderTrackingDetails(list[0])

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }

  const CalculateGrandTotal = (
    price,
    convenienceFee,
    needSamagri,
    samagriPrice,
    discount
  ) => {
    return (
      totalPrice(price, convenienceFee, needSamagri, samagriPrice, discount) +
      Math.round(
        (ServiceDiscounts.panditBookingDiscount / 100) *
        Number(
          totalPrice(
            price,
            convenienceFee,
            needSamagri,
            samagriPrice,
            discount
          )
        )
      )
    );
  };

  const totalPrice = (
    price,
    convenienceFee,
    needSamagri,
    samagriPrice,
    discount
  ) => {
    return (
      Number(price) +
      Number(convenienceFee) +
      (needSamagri === "yes" ? Number(samagriPrice) : 0) -
      discount
    );
  };

  const Remaining_Amount = Math.round(order?.RemainingAmount);

  const handleProceedRemainingPujaPayment = async () => {
    //  ;
    if (Remaining_Amount === 0) {
      alert("All the amount already paid");
      return;
    }

    let orderIDReturned = order.PB_ID;
    // let minPayableAmount = modelRequestData.amountEntered
    //   ? modelRequestData.amountEntered
    //   : Math.round(grandTotal);

    const PlaceOrderResponse = await handleProceedRemainingPayment(Math.round(order.RemainingAmount))

    setLoader(true)
    if (PlaceOrderResponse?.status === 1) {
      axios
        .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=Pandit`, {
          USER_ID: userID,
          ORDER_ID: orderIDReturned,
          // ORDER_ID: JSON.parse(localStorage.getItem("orderID")),
          TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
          PAYMENT_STATUS: "Completed",
          TRANSACTION_STATUS: "Success",
          TRANSACTION_AMT: order.RemainingAmount,
          REMAING_AMOUNT: 0,
          PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
        })
        .then((res) => {

          if (res.data.ResponseMessage === "Success.") {
            setLoader(false)
            navigate("/my-order-puja-booking");
          } else {
            setLoader(false)
            alert("Order placement failed, please try again.");
          }
        });
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Order Failed !')
    }
  };
  const handlePhonePayProceedRemainingPayment = async () => {
    //  ;
    if (Remaining_Amount === 0) {
      alert("All the amount already paid");
      return;
    }

    let orderIDReturned = order.PB_ID;
    const PhonePayOption = {
      UserID: userID,
      MobileNumber: 7218511742,
      ModalName: 'poojaBookingRemaining',
      Amount: order.RemainingAmount,
    };



    const Payload = {
      USER_ID: userID,
      ORDER_ID: orderIDReturned,
      // TRANSACTION_ID: paymentId,
      PAYMENT_STATUS: "Completed",
      TRANSACTION_STATUS: "Success",
      TRANSACTION_AMT: order.RemainingAmount,
      REMAING_AMOUNT: 0,
      PAYMENT_DATE: dayjs().format("YYYY-MM-DD")
    }
    axios
      .post(`${BaseUrl}/${GetPhonePayPaymentLink}`, PhonePayOption)
      .then((res) => {
        if (res?.data?.success) {


          // Use navigate with state instead of window.location.href
          localStorage.setItem('PujaBookingData', JSON.stringify(Payload));

          window.location.href = res.data.redirectUrl;
        } else {
          console.error("PhonePe Payment Failed:", res.data);
          alert("Something went wrong while creating the payment link.");
        }
      })
      .catch((error) => {
        console.error("PhonePe API Error:", error);
        alert("Failed to initiate PhonePe payment. Please try again.");
      });
  };





  console.log(order);

  const paymentBtnClick = () => { };

  const createMarkup = (html) => {
    return { __html: html };
  };

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }
  const handleDownloadInvoice = (PB_ID) => {
    window.open(order?.InvoicePDFURL, "_blank");
    // const pdfUrl = order?.InvoicePDFURL; // Replace with your actual URL
    // const link = document.createElement("a");

    // link.href = pdfUrl;
    // link.download = `Invoice_${PB_ID}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };
  const deliveryStatus = {
    currentStatus: "shipped", // Options: processed, shipped, enroute, arrived
  };

  const stepMap = [
    { key: "BookingDate", label: "Processed" },
    { key: "ConfirmedDate", label: "Confirmed" },
    { key: "CompletedDate", label: "Completed" },
    { key: "CancelledDate", label: "Cancelled" },
    { key: "RejectedDate", label: "Rejected" }
  ];



  return (
    <>
      <div>
        <div className="top">
          <div
            className="pujaDetails custom-flex"
            style={{
              display: "flex",
              padding: "20px",
              alignItems: "flex-start",
              maxHeight: "80vh", // restrict overall height
              overflow: "hidden", // prevent container from overflowing
            }}
          >
            <div
              className="left"
              style={{
                position: "sticky",
                top: "20px",
                flexShrink: 0,
              }}
            >
              <img
                src={order.PUJA_IMAGE || placeholderImg}
                width={100}
                height={300}
                style={{ objectFit: "contain" }}
                alt="Puja-Img"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = placeholderImg;
                }}
                className="OrderDetailsImage"
              />

            </div>

            <div
              className="right"
              style={{
                marginLeft: "20px",
                overflowY: "auto",
                maxHeight: "80vh", // match the parent height
                paddingRight: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center", // Ensures vertical alignment
                  marginBottom: "10px",
                }}
              >
                {/* <h6
                  className="list-group-item custom-list-item clearfix"
                  style={{
                    fontFamily: "Bricolage Grotesque",
                    fontSize: "20px",
                    textTransform: "none",
                    margin: 0, // Remove default margin for better alignment
                  }}
                >
                  Puja Details
                </h6> */}
                <h2
                  style={{
                    fontFamily: "Bricolage Grotesque",
                    fontSize: "20px",
                    textTransform: "none",
                    margin: 0, // Remove default margin for better alignment
                  }}
                >
                  {order.PUJA_NAME}
                </h2>
                {Remaining_Amount > 0 && (
                  <div className="button-container">
                    <button
                      className="Normal-app-btn"
                      onClick={() => handleProceedRemainingPujaPayment()}
                    >
                      Proceed To Payment
                    </button>
                    {/* <button
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#A52444",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={handlePhonePayProceedRemainingPayment}
                    >
                      Proceed To Phone Pay Payment
                    </button> */}
                  </div>
                )}
              </div>
              {/* ... your right side content ... */}




              <h4>
                Rs{" "}
                {/* {order.PB_PRICE -
                  Math.round((order.PB_PRICE * order.pujaDiscount) / 100)} */}
                {formatToIndianCurrency(order.PB_PRICE - order.DiscountAmount)}
              </h4>
              {/* <h5>
                <span>
                  <s>Rs {order.PB_PRICE}</s>
                </span>
              </h5> */}

              <div className="mb-3 ">
                <h5>{t("Puja Details")}:</h5>
                <p
                  dangerouslySetInnerHTML={{
                    __html: order.PUJA_DETAILS,
                  }}
                />
              </div>
              {order.PUJA_SAMAGRI !== null && order.PUJA_SAMAGRI !== undefined && order.CategoryType !== "Deepdaan" && (
                <>
                  <div className="mb-3">
                    <h5>{t("Samagri")}:</h5>
                    {order.PB_SAMAGRI ? (
                      <div
                        dangerouslySetInnerHTML={createMarkup(
                          order.PUJA_SAMAGRI
                        )}
                      />
                    ) : (
                      ''
                    )}
                  </div>

                  {/* <h5>
                    Samagri Price: Rs{" "}
                    {formatToIndianCurrency(Number(order.PB_SAMAGRIPRICE) )}
                  </h5> */}
                </>
              )}
              {order.CategoryType === "Deepdaan" && (
                <span style={{ marginTop: "15px" }}>
                  {" "}
                  {t("Deepdaan Note")}: {order.Remark}
                </span>
              )}

              {/* <div className="button-container">
              <button
                className="btn btn-primary"
                style={{ backgroundColor: "#A52444", color: "white" }}
                onClick={handleOpenProductBookingModal}
              >
                Proceed to Book
              </button>
            </div> */}


            </div>
          </div>

        </div >
        {(OrderTrackingDetails !== null && OrderTrackingDetails !== undefined && OrderTrackingDetails !== '') && (

          <div >
            <LazySection><DeliveryTracker statusData={OrderTrackingDetails} stepMap={stepMap} /></LazySection>
          </div>
        )}
        <div className="container my-4">
          <div className="row g-4">
            {/* Puja Details */}
            <div className="col-md-4">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center fw-bold">
                    {t("Puja Details")}
                  </h5>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{t("Puja Name")}</td>
                        <td className=" fw-bold">{order.PUJA_NAME}</td>
                      </tr>
                      <tr>
                        <td>{t("Booking Date")}</td>
                        <td>{order.REG_DATE}</td>
                      </tr>
                      <tr>
                        <td>{t("Puja Type")}</td>
                        <td>{t(order.PoojaType)}</td>
                      </tr>
                      {order.CategoryType === "Deepdaan" ? (
                        <tr>
                          <td>{t("Whatsapp Number")}</td>
                          <td>{order.WhatsappNumber}</td>
                        </tr>
                      ) : (
                        <tr>
                          <td>{t("Language")}</td>
                          <td>{order.PB_LANGAUGE}</td>
                        </tr>
                      )}
                      <tr>
                        <td>{t("Puja Date")}</td>
                        <td>{order.PB_DATE}</td>
                      </tr>
                      {order.CategoryType !== "Deepdaan" && (
                        <tr>
                          <td>{t("Time")}</td>
                          <td>{order.PB_TIME}</td>
                        </tr>
                      )}
                      {order.NeedDrySamagri === "yes" && order.NeedWetSamagri === "yes" ?
                        <tr>
                          <td>{t("Samagri")}</td>
                          <td>{t("Yes")}</td>
                        </tr>
                        : order.NeedDrySamagri === "yes" && order.NeedWetSamagri === "no" ?
                          <tr>
                            <td>{("Dry Samagri")}</td>
                            <td>{("Yes")}</td>
                          </tr> : order.NeedDrySamagri === "no" && order.NeedWetSamagri === "yes" ?
                            <tr>
                              <td>{t("Wet Samagri")}</td>
                              <td>{t("Yes")}</td>
                            </tr> : ''
                      }

                      <tr>
                        <td>{t("Payment Mode")}</td>
                        <td>
                          <i className="bi bi-credit-card"></i>{" "}
                          {t(order.PAYMENT_TYPE)}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("Payment Status")}</td>
                        <td className="fw-bold ">
                          {order.PAYMENT_STATUS === "Complete"
                            ? t("Completed")
                            : t(order.PAYMENT_STATUS)}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("Transaction Amount")} (₹)</td>
                        <td>{formatToIndianCurrency(order.TRANSACTION_AMT)}</td>
                      </tr>
                      <tr>
                        <td>{t("Remaining Amount")} (₹) </td>
                        <td>
                          {formatToIndianCurrency(order.RemainingAmount) || 0}
                          {/* {formatToIndianCurrency(
                            CalculateGrandTotal(
                              order.PB_PRICE,
                              order.CONVENIENCE_FEE,
                              order.PB_SAMAGRI,
                              order.PB_SAMAGRIPRICE,
                              order.DiscountAmount
                            ) - order.TRANSACTION_AMT
                          ) || 0} */}
                          {/* {formatToIndianCurrency(
                            Number(order.PB_PRICE) +
                              Number(
                                order.PB_SAMAGRI === "yes"
                                  ? order.PB_SAMAGRIPRICE
                                  : 0
                              ) +
                              Number(order.CONVENIENCE_FEE) +
                              Tax -
                              order.TRANSACTION_AMT
                          ) || 0} */}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* Pandit Details */}
            {order.CategoryType !== "Deepdaan" ? (
              <div className="col-md-4">
                <div className="card shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-center fw-bold">
                      {t("Pandit Details")}
                    </h5>
                    <table className="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <td>{t("Pandit Name")}</td>
                          <td className=" fw-bold">{order.PANDIT_NAME === null || order.PANDIT_NAME === undefined ? 'Pending' : order.PANDIT_NAME}</td>
                        </tr>
                        <tr>
                          <td>{t("Contact")}</td>
                          <td>{order.PANDIT_NAME === null || order.PANDIT_NAME === undefined ? 'Pending' : order.MOBILE_NO}</td>
                        </tr>
                        <tr>
                          <td>{t("Status")}</td>
                          <td className="fw-bold">
                            {order.PANDIT_STATUS === "Complete"
                              ? t("Completed")
                              : t(order.PANDIT_STATUS)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-2"></div>
            )}
            {/* Price Details */}
            <div className="col-md-4">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center fw-bold">
                    {t("Price Details")}
                  </h5>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{t("Puja Price")} (₹)</td>
                        <td className="text-end">
                          {formatToIndianCurrency(
                            Math.round(
                              Number(order.PB_PRICE) -
                              Number(order.DiscountAmount)
                            ) || 0
                          )}
                        </td>
                      </tr>
                      {/* <tr>
                        <td>Discount ({order.PUJA_DISC}%)</td>
                        <td className="text-end">
                          {Math.round(order.DiscountAmount)}
                        </td>
                      </tr> */}
                      {order.NeedDrySamagri === "yes" && order.NeedWetSamagri === "yes" && order.NeedWetSamagri !== null && order.NeedDrySamagri !== null ? (
                        <tr>
                          <td> {t("Samagri Price")} (₹)</td>
                          <td className="text-end">
                            {formatToIndianCurrency(
                              Math.round(
                                (Number(order.WetSamagriPrice) +
                                  Number(order.WetSamagriPriceTaxAmount === null ? 0 : order.WetSamagriPriceTaxAmount)) + (Number(order.DrySamagriprice) +
                                    Number(order.DrySamagriPriceTaxAmount === null ? 0 : order.DrySamagriPriceTaxAmount))
                              )
                            )}
                          </td>
                        </tr>
                      ) : order.NeedDrySamagri === "yes" && order.NeedWetSamagri === "no" && order.NeedWetSamagri !== null && order.NeedDrySamagri !== null ? (
                        <tr>
                          <td>{t("Dry Samagri Price")} (₹)</td>
                          <td className="text-end">
                            {formatToIndianCurrency(
                              Math.round(
                                (Number(order.DrySamagriPrice) +
                                  Number(order.DrySamagriPriceTaxPercent === null ? 0 : order.DrySamagriPriceTaxPercent))
                              )
                            )}
                          </td>
                        </tr>
                      ) : order.NeedDrySamagri === "no" && order.NeedWetSamagri === "yes" && order.NeedWetSamagri !== null && order.NeedDrySamagri !== null ? (
                        <tr>
                          <td>{t("Wet Samagri Price")} (₹)</td>
                          <td className="text-end">
                            {formatToIndianCurrency(
                              Math.round(
                                Number(order.WetSamagriPrice) +
                                Number(order.WetSamagriPriceTaxAmount === null ? 0 : order.WetSamagriPriceTaxAmount)
                              )
                            )}
                          </td>
                        </tr>
                      ) : ''}

                      {/* <tr>
                        <td>Samagri Tax ({order?.SamagriPriceTaxPercent}%)</td>
                        <td className="text-end">
                          {order.SamagriPriceTaxAmount === 0.0
                            ? 0.0
                            : formatToIndianCurrency(
                              order.SamagriPriceTaxAmount
                            )}
                        </td>
                      </tr> */}
                      {Number(order.CONVENIENCE_FEE) !== 0 && (
                        <tr>
                          <td>{t("Convenience Fee")} (₹)</td>
                          <td className="text-end">
                            {formatToIndianCurrency(
                              Math.round(
                                Number(order.CONVENIENCE_FEE) +
                                Number(order.ConvinienceFeeTaxAmount)
                              )
                            )}
                          </td>
                        </tr>
                      )}
                      {order.CouponCodeAmount !== 0 ? (
                        <tr>
                          <td>
                            {t("Coupon Amount")} (₹)
                          </td>
                          <td className="text-end">
                            {order.CouponCodeAmount}
                          </td>
                        </tr>
                      ) : order.WalletAmount !== 0 ?
                        <tr>
                          <td>
                            {t("Wallet Amount")} (₹)
                          </td>
                          <td className="text-end">
                            {order.WalletAmount}
                          </td>
                        </tr> : ''}


                      <tr className="fw-bold">
                        <td>{t("Total Amount")} (₹)</td>
                        <td className="text-end">
                          {formatToIndianCurrency(order.PB_GrandTotal)}
                          {/* {formatToIndianCurrency(
                            CalculateGrandTotal(
                              order.PB_PRICE,
                              order.CONVENIENCE_FEE,
                              order.PB_SAMAGRI,
                              order.PB_SAMAGRIPRICE,
                              order.DiscountAmount
                            )
                          )} */}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {order.PAYMENT_STATUS === "Complete" && (
                <a
                  target="_blank"
                  className="careox-btn mt-2"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleDownloadInvoice(order.PB_ID)}
                >
                  {t("Download Invoice")}
                </a>

              )}

              {/* <button
                className="careox-btn mt-2 mx-2"
                onClick={() => {
                  if (order.PAYMENT_TYPE === "COD") {
                    navigate("/receipt-details", {
                      state: {
                        moduleName: "PanditBooking",
                        orderID: order.PB_ID,
                      },
                    });
                  } else {
                    navigate("/view-receipt", {
                      state: {
                        moduleName: "PanditBooking",
                        orderID: order.PB_ID,
                      },
                    });
                  }
                }}
              >
                View Receipt
              </button> */}
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default PBOrderDetails;
